import {useEffect, useState} from "react"
import {ShoppingBag, ShoppingBagAggregate} from "../../models/shoppingbag"

export const useBagFlashNotification = (
    bagModel: ShoppingBag | null,
    newCookieTimestamp: Date | null,
    oldCookieTimestamp: Date | null = null,
    enabled = true,
    timeout = 4,
) => {
    const [shouldShowBagNotification, setShouldShowBagNotification] = useState(false)

    useEffect(() => {
        if (!enabled) return
        if (!bagModel) return
        if (!newCookieTimestamp) return

        if (oldCookieTimestamp && newCookieTimestamp) {
            const timeDifference = Math.abs(newCookieTimestamp.getTime() - oldCookieTimestamp.getTime()) // difference in milliseconds
            const hourDifference = timeDifference / (1000 * 60 * 60)

            if (hourDifference < timeout) return
        }

        const bag = new ShoppingBagAggregate(bagModel)
        if (bag.IsEmpty() || bag.AllItemsOutOfStock()) return

        setShouldShowBagNotification(true)
    }, [bagModel, bagModel?.Authenticated, enabled, oldCookieTimestamp, newCookieTimestamp, timeout])

    return {
        shouldShowBagNotification,
        setShouldShowBagNotification,
    }
}
